export default __webpack_public_path__ + "62e10d305f53ea6f52fa6746015306f8.png";